(ns frontend.view.login.components.common
  (:require
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]))

(defn logo
  []
  [:div.login__logo__container
   [rbs/Image
    {:fluid      true
     :src        "https://static.zapflow.com/app/img/pdfmemo/zapflow-logo_color-RGB.svg"
     :alt        (loc/tr :zapflow)
     :class-name "d-block img-fluid login__logo"}]])

(defn form-group
  [{:keys [control-id label type value autocomplete on-change! on-key-down! validation-error]}]
  (let [focus-state (atom {})]
    (fn [{:keys [control-id label type value autocomplete on-change! on-key-down! validation-error]}]
      [rbs/FormGroup
       {:control-id control-id
        :size       "lg"
        :class-name "zap-form__light-grey__green__dark-grey relative"}
       [rbs/FormLabel label]
       [:input
        {:placeholder   ""
         :ref           (fn [dom-ref]
                          (when (and dom-ref
                                     (not= dom-ref (:dom-ref @focus-state)))
                            (swap! focus-state assoc :dom-ref dom-ref)
                            (.focus dom-ref)))
         :type          type
         :id            control-id
         :class-name    (str "form-control")
         :value         (or value "")
         :on-key-down   on-key-down!
         :auto-complete autocomplete
         :on-change     on-change!}]
       (when validation-error
         [:label.zap-form__validation-error
          validation-error])])))

(defn right-side
  []
  [rbs/Jumbotron
   {:class-name "login__right__jumbotron"}
   [:div.login__right__jumbotron__title "Power tool for professional investors"]
   [:div.login__right__jumbotron__message "Manage your deals better with less effort"]])
